import React from 'react';
import { BsViewStacked } from 'react-icons/bs';
import { FaArrowLeft } from 'react-icons/fa';
import { useSteps } from '../../contexts/stepContext';
import { Title } from '../../styles/global';
import { Content, GoBack } from '../BodyStep/styles';
import Button from '../Button';
import TableArea from '../TableArea';
import { Container, Message, MessageContainer } from './styles';

const CSVResults: React.FC = () => {
  const {
    handleReturnCurrentStep,
    handleInitialCurrentStep,
    processingPlates,
    diffPlates,
  } = useSteps();
  return (
    <Content>
      <GoBack onClick={handleReturnCurrentStep}>
        <FaArrowLeft size={16} />
        voltar
      </GoBack>
      <Title>Relação de Veículos</Title>
      <MessageContainer>
        <Message>Foram processadas {processingPlates} Placas</Message>
        <Message>Resultados da Busca</Message>
      </MessageContainer>
      {!diffPlates ? (
        <Container>
          <TableArea />
        </Container>
      ) : (
        <MessageContainer>
          <Message>Não foram encontrados resultados</Message>
        </MessageContainer>
      )}

      <Button
        title="Voltar para Operacoes"
        onClick={handleInitialCurrentStep}
        icon={BsViewStacked}
      />
    </Content>
  );
};

export default CSVResults;
